import type { PipeTransform } from '@angular/core'
import { Pipe } from '@angular/core'

@Pipe({ name: 'join' })
export class JoinPipe implements PipeTransform {
  transform<T>(
    value: T[] | undefined,
    property?: keyof T,
    separator = ' , '
  ): string {
    if (!value || !Array.isArray(value)) {
      return ''
    }

    const items = property
      ? value
          .map(item => item[property])
          .filter(item => item !== null && item !== undefined)
      : value.filter(item => item !== null && item !== undefined)

    return items.reduce((acc, curr, idx) => {
      if (idx === 0) return curr as string
      if (idx === items.length - 1) return `${acc}${separator.trim()}${curr}`
      return `${acc}${separator}${curr}`
    }, '')
  }
}
